module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "half-width margin-auto"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Ingrese sus credenciales")]), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Usuario"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._m(1)])]), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._m(2)])]), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-empresa",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Ingresar")])])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.errorMessage) ? _c('article', {
    staticClass: "message is-danger"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])])]) : _vm._e()])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/logo.png",
      "alt": "logo"
    }
  }), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Admnistrador de libro de reclamaciones")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00ff8053","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Login.vue
// module id = 75
// module chunks = 0